import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@cimpress/react-components';

import '../css/slider.css';

import { round, truncateZeros } from '../util/number';

const fixNumber = (num, inc) => truncateZeros(round(num, inc));

export default class Slider extends Component {
    state = {
        currentValue: this.props.value,
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== fixNumber(this.state.currentValue, nextProps.increment)) {
            this.setState({ currentValue: nextProps.value });
        }
    }

    onDragMove = (e) => {
        const { max, min } = this.props;
        const bar = this.bar.getBoundingClientRect();
        if (e.clientX <= bar.left) {
            this.setState({ currentValue: min });
        } else if (e.clientX >= bar.right) {
            this.setState({ currentValue: max });
        } else {
            const range = max - min;
            const percentage = (e.clientX - bar.left) / bar.width;
            const value = min + (percentage * range);
            this.setState({ currentValue: value });
        }
    }

    onDragEnd = () => {
        document.onmousemove = () => {};
        document.onmouseup = () => {};
        this.setState({ dragging: false });
        this.props.onSelect(fixNumber(this.state.currentValue, this.props.increment));
    }

    onDragStart = (e) => {
        if (!this.props.disabled) {
            this.setState({ dragging: true });
            document.onmousemove = this.onDragMove.bind(this);
            document.onmouseup = this.onDragEnd.bind(this);
            this.onDragMove(e);
        }
    }

    onMouseOver = () => {
        this.setState({ hover: true });
    }

    onMouseOut = () => {
        this.setState({ hover: false });
    }

    /* eslint-disable no-return-assign */
    render() {
        const { currentValue, hover, dragging } = this.state;
        const { label, min, max, disabled, increment } = this.props;
        const left = `${100 * ((currentValue - min) / (max - min))}%`;
        const focusClass = hover || dragging ? ' slider--focus' : '';
        return (
            <div
                className={`slider${focusClass}`}
                disabled={disabled}
                onMouseOver={this.onMouseOver}
                onFocus={this.onMouseOver}
                onMouseOut={this.onMouseOut}
                onBlur={this.onMouseOut}
            >
                {label && <div className='slider__title'>{label}</div>}
                <div ref={ref => this.bar = ref} className='slider__bar' onMouseDown={this.onDragStart} >
                    <div className='slider__progress-bar' style={{ width: left }} />
                </div>
                <div className='slider__handle' style={{ left }}>
                    <Tooltip
                        direction='bottom'
                        show={!!focusClass}
                        variety='popover'
                        contents={fixNumber(currentValue, increment)}
                    >
                        <div
                            className='slider__virtual-handle'
                            onMouseDown={this.onDragStart}
                        />
                    </Tooltip>
                </div>
                <div className='slider__values'>
                    <div className='slider__min'>{min}</div>
                    <div className='slider__max'>{max}</div>
                </div>
            </div>
        );
    }
}

Slider.propTypes = {
    label: PropTypes.string,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onSelect: PropTypes.func.isRequired,
    increment: PropTypes.number,
};

Slider.defaultProps = {
    increment: 1,
    min: 0,
    max: 100,
};



// WEBPACK FOOTER //
// ./src/components/Slider.jsx